<template lang="pug">
    el-dialog(:title="!dataForm.id ? '新建': '修改'",width="95%",:visible.sync='visible' :modal-append-to-body='false' :append-to-body='true')
        el-form(:model="dataForm", :inline="false" :rules="rules", ref="dataForm", label-width="100px", @submit.native.prevent)
          el-card(shadow="never")
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 基本信息
            div 
              el-row(:span='24')
                el-col(:md='6' :sm="12")  
                    el-form-item(label="名称" prop="name")
                        el-input.inputWidth(v-model='dataForm.name' clearable)
                el-col(:md='6' :sm="12")  
                    el-form-item(label="日期" prop="checkonTime")
                        el-date-picker.inputWidth(v-model='dataForm.checkonTime' value-format="yyyy-MM-dd"  type="date" clearable)
                el-col(:md='6' :sm="12")
                    el-form-item(label="时段" prop="startTime" style='float:left')
                        el-time-select(style='width:115px' v-model='dataForm.startTime' :picker-options="{start: '00:00',step: '01:00',end: '24:00'}" )
                    el-form-item(label="    --" prop="endTime" style='float:left;margin-left: -72px' :hide-required-asterisk="false")
                        el-time-select(style='width:115px' v-model='dataForm.endTime' :picker-options="{start: dataForm.startTime,step: '01:00',end: '24:00',minTime:dataForm.startTime}" )
        el-card(shadow="never")
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 添加考勤  
            div
                el-form(:model="px", :inline="false", ref="searchForm", label-width="100px", @submit.native.prevent)
                    el-row(:span='24')
                        el-col(:md='5' :sm="12")   
                            el-form-item(label="培训ID：" prop="pxid"  )
                                el-input.inputWidth(v-model="px.pxid" placeholder="请输入培训ID" clearable)
                        el-col(:md='5' :sm="12")     
                            el-form-item(label="培训名称：" prop="pxName")
                                el-input.inputWidth(v-model='px.pxName' placeholder="请输入培训名称"  clearable ) 
                        el-col(:md='5' :sm="12")     
                            el-form-item(label="教练：" prop="coachName")
                                el-input.inputWidth(v-model='px.coachName' placeholder="教练名称"  clearable )       
                        el-col(:md='5' :sm="12")        
                            el-form-item(label="主办方：" prop="orgId")
                                el-select.inputWidth(v-model="px.orgId" placeholder="请选择主办方" filterable clearable @change="changeCity")
                                    el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )  
                        el-col(:md='4' :sm="12")     
                            el-form-item(label="培训类型：" prop="pxType")
                                el-select.inputWidth(v-model='px.type' clearable )
                                    el-option(v-for="(e, i) in pxType2" :key="i" :label="e.label" :value="e.value")
                    el-row(:span='24')
                        el-col(:md='5' :sm="12")
                            el-form-item(label="培训场地：" prop="venueId")
                                el-select.inputWidth(v-model="px.venueId" placeholder="请先选择主办方" :disabled="!px.orgId" filterable clearable)
                                    el-option(v-for="(item,index) in placeList" :key="index" :label="item.name" :value="item.id")
                        el-col(:md='5' :sm="12")        
                            el-form-item(label="培训级别：" prop="level")
                                el-select.inputWidth(v-model='px.level'  clearable  placeholder="请选择级别")
                                    el-option(v-for="item in pxLevel" :label="item.label" :value="item.value")
                        el-col(:md='5' :sm="12")        
                            el-form-item(label="培训时间：" prop="date") 
                                el-date-picker(v-model="px.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期")
                        el-col(:md='9' :sm="12" style='text-align:right;')
                            el-button(@click="getTrainSubmitAdd()" type='success' ) 添加
                            el-button(@click="getTrainSubmit()"  type='success'  icon='el-icon-search' ) 查询 
                el-table(:data="trainList" @selection-change="checkAll" v-loading="dataListLoading" border)
                        el-table-column(type='selection', header-align='center', align='center', width='50')
                        el-table-column(prop="trainCode" label="培训ID" align='center')
                        el-table-column(prop="name" label="培训名称" align='center')
                        el-table-column(prop="orgName" label="主办方" align='center')
                        el-table-column(prop="type" label="培训类别" align='center')
                            template(slot-scope="scope")
                                font {{pxType[scope.row.type]}}
                        el-table-column(prop="classCount" label="班级人数" align='center' sortable)
                        el-table-column(prop="level" label="培训级别" align='center' sortable )
                        el-table-column(prop="applyStrTime" label="培训开始时间" align='center' sortable )
                        el-table-column(prop="placesName" label="培训场地" align='center')
                        el-table-column(prop="coachName" label="教练" align='center')
                el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        br
        el-card(shadow="never")
              div(slot="header")
                  font(style="font-weight: bold;font-size:18px;") 考勤表
              div
                  el-row
                    el-col(:span='24' style='margin-bottom:15px;')
                        div(style="float:right") 
                            el-button(type="danger" @click="deleteLine()" :disabled="delTableList.length<1") 删除
                            el-button(type="danger" @click="deleteAll()") 清空列表
                  el-table(:data="dataForm.rightTable" border  @selection-change='selectionChangeHandle')
                        el-table-column(type='selection', header-align='center', align='center', width='50')
                        el-table-column(prop="trainCode" label="培训ID" align='center')
                        el-table-column(prop="name" label="培训名称" align='center')
                        el-table-column(prop="orgName" label="主办方" align='center')
                        el-table-column(prop="type" label="培训类别" align='center')
                            template(slot-scope="scope")
                                font {{pxType[scope.row.type]}}
                        el-table-column(prop="classCount" label="班级人数" align='center' sortable)
                        el-table-column(prop="level" label="培训级别" align='center' sortable)
                        el-table-column(prop="applyStrTime" label="培训开始时间" align='center' sortable)
                        el-table-column(prop="placesName" label="培训场地" align='center')
                        el-table-column(prop="coachName" label="教练" align='center')
        br  
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="ruleFormSubmit()") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script> 
 import commonData from "../common.js"
    export default {
        data(){
            return{
                pxLevel: commonData.pxLevel,
                pxType2: commonData.pxType2,
                pxType: commonData.pxType,
                dataListLoading:true,
                visible:false,
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                trainList:[],
                dataForm:{
                    id:null,
                    name: null,
                    title:null, 
                    checkonTime:'',
                    startTime:'',
                    endTime:'',
                    rightTable:[],
                    ctEnrollPriceList:[]
                },
                nowSelectData: [], // 选中px列表数据
                delTableList:[], // 考勤列表选中数据
                sysOrgList:[],
                placeList:[],
                px:{
                    pxid:null,//培训id
                    coachName:'',//教练
                    pxName:null,//培训名称
                    orgId:null,//主办方ID
                    type:null,//培训类型
                    level:null,//级别
                    venueId:'',
                    applyStrTime: '',//开始时间
                    applyEndTime: '',//开始时间
                    date:[]
                },
                rules:{
                    name:[
                        {required: true, message: '标题不能为空!', trigger: 'blur'},
                        // { max: 20, message : '长度不能超过20个字符!'}
                    ],
                    checkonTime:[
                        {required: true,message: '日期不能为空!', trigger: 'blur' }
                    ],
                    startTime:[
                        {required: true,message: '开始时间不能为空!', trigger: 'blur' }
                    ], 
                    endTime:[
                        {required: true,message: '结束时间不能为空!', trigger: 'blur' }
                    ], 
                },
            }
        }, 
        computed:{
            searchData(){
                let data = {
                    rows: this.pageSize, 
                    trainCode:this.px.pxid,
                    name: this.px.pxName, 
                    orgId:this.px.orgId,
                    page: this.pageIndex,
                    limit: this.pageSize,
                    coachName:this.px.coachName,
                    type:this.px.type,
                    placesId:this.px.venueId,
                    level :this.px.level,
                    strTime:this.px.date[0],//开始时间
                    endTime:this.px.date[1]//结束时间
                }
                return data
            }
        },
        mounted() {
            //this.restaurants = this.loadAll()
           this.initCity()
        },
        methods:{
             //查询培训信息表
            getTrainSubmit(){
                this.$http({
                    url: this.$http.adornUrl("/pxTrain/list"),
                    method: "post",
                    data:this.searchData
                }).then(data => {
                    if (data && data.code === 0) {
                        this.trainList=data.page.records
                        this.totalPage = data.page.total;
                    } else {
                        this.trainList = [];
                        this.totalPage = 0;
                    }
                    this.dataListLoading = false;
                });
            },
            init(id){ 
                
                this.dataForm.id = id || null
                this.clickFlag = false
                this.visible = true
                //数据初始化
                this.dataForm.rightTable=[]
                 //修改回选  
                this.$nextTick(()=>{
                    this.$refs.dataForm.resetFields();
                    this.$refs.searchForm.resetFields();
                    this.getTrainSubmit()
                })
                if(this.dataForm.id){
                    console.log(this.trainList,8989);
                    
                    this.$http({ 
                        url: this.$http.adornUrl(`/pxCheckon/getId/`+this.dataForm.id),
                        method: 'get'
                    }).then((data) =>{ 
                        if(data && data.code === 0){
                            console.log("data:",data)
                            this.dataForm = data.bean
                            this.dataForm.rightTable=data.resultList   
                            this.nowSelectData = data.resultList
                        }
                    })
                }
            },
            
            //新增方法
            ruleFormSubmit(){
                let idArr =[]
                let pid = '' 
                if(this.dataForm.rightTable.length>0) { 
                    this.$showLoading()
                    let arr = this.dataForm.rightTable 
                    arr.forEach(e=>{
                       idArr.push(e.id) 
                    })
                    pid = idArr.join()
                }
                let data = {
                    id:this.dataForm.id,
                    name: this.dataForm.name,
                    title:this.dataForm.name,
                    checkonTime:new Date(this.dataForm.checkonTime).getTime(), 
                    startTime: new Date(this.dataForm.checkonTime +'  ' + this.dataForm.startTime ).getTime()  || null,
                    endTime: new Date(this.dataForm.checkonTime +'  ' + this.dataForm.endTime ).getTime()  || null,
                    pid:pid
                }
                
                console.log(data,'数据');
                this.$refs.dataForm.validate(val=>{
                    if(val){
                        this.$http({
                            url:this.$http.adornUrl(`/pxCheckon/${!this.dataForm.id ? 'save' : 'update'}`),
                            method:"post",
                            data: data
                        }).then((data) =>{
                                if(data && data.code === 0){
                                this.$message({
                                    message:'操作成功',
                                    type:'success',
                                    duration: 1500,
                                    onClose:()=>{
                                        this.visible = false
                                        this.$showLoading('close')
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } 
                        }) 
                    }
                })
                       
            },
            deleteAll(){
                this.dataForm.rightTable = [];
                this.$forceUpdate()
            },
            //将选中的考勤转移到考勤table中
            getTrainSubmitAdd(){
                let arr = []
                if(this.dataForm.rightTable.length>0){
                    this.dataForm.rightTable.forEach(e => {
                    arr.push(e.id)
                });
                }
                
                let checkedArr = [] //已经选了
                let newArr = [] //未选择的
                if(this.nowSelectData.length>0){
                    this.nowSelectData.forEach(n=>{
                        if(arr.indexOf(n.id)> -1){
                            checkedArr.push(n.name)
                        }else{
                        newArr.push(n) 
                        }
                    })
                }else{
                    this.$message.error(`未勾选任何项目！`)
                }
                
                if(checkedArr.length>0){
                    this.$message.error(`【${checkedArr.join()}】已添加！`)
                }
                console.log(newArr,789);
                
                this.dataForm.rightTable = this.dataForm.rightTable.concat(newArr)
                console.log(this.dataForm.rightTable,888);
                this.$forceUpdate()
                
            }, 
            // table多选事件
            selectionChangeHandle (val) {
                this.delTableList = val 
            },
            // 多选删除
            deleteLine(){ 
                this.dataForm.rightTable = this.deleChecked(this.dataForm.rightTable,this.delTableList)
                this.$forceUpdate()
            },
            deleChecked(oldArr,delArr){
                let arr = []
                delArr.forEach(e => {
                    arr.push(e.id)
                });
                let nowArr = oldArr.filter(n=>arr.indexOf(n.id) == -1)
                return nowArr
            },
            initCity () {
                this.$http({
                    url: this.$http.adornUrl('/sysOrg/list'),
                    method: 'get'
                }).then((data) => {
                    this.sysOrgList = data && data.code === 0 ? data.list : []
                })
            },
            changeCity () {
                this.selectCity()
            },
            selectCity(){
                this.$http({
                    url: this.$http.adornUrl("/pbPlaces/getPlaceById"),
                    method: "get",
                    params: this.$http.adornParams({
                        'orgId': this.px.orgId,
                        'proviceId': '',
                        'cityId':''
                    })
                }).then(data => {
                    this.placeList = data && data.code === 0 ? data.list : [];
                });
            },
            
           
            
            // 每页数
            sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getTrainSubmit();
            },
            // 当前页
            currentChangeHandle(val) {
            this.pageIndex = val;
            this.getTrainSubmit();
            },
            checkAll(val){
                this.nowSelectData = val;
            } 
        }
    }
</script>
<style>
    .inputWidth{
        width: 220px;
    }
  

    .font_later{
        padding-left:20px;
        font-weight: bold;
        color: #909399;
    }
    .font_color{
        font-weight: bold;
        color: #909399;
    }
    .font_style{
        font-weight: bold;
        color: red;
    }
    .dialog-footer{
        padding-bottom:150px;
    }

    /* 提示框 */
.el-tooltip__popper.is-light{
  border: 1px solid #C0C4CC;
}

.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: grey  !important ;
}

.toolTip>p{
  margin: 0;
  padding-top: 10px;
  height:14px;
  line-height:14px;
  font-size:14px;
  color: #606266;
}


 /* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

</style>